import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MiningTileRewardFees = ({ data, formatLargeNumber, animate }) => {
  const numberValue = data?.ts11?.rewards144?.totalFee != null
    ? `${formatLargeNumber(data.ts11.rewards144.totalFee, 2, false) + ' Sats' ?? "Loading..."}`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Fees BTC 24h" value={numberValue} />
    </ThemedFlex>
  );
};
